import { ReactNode } from 'react';
import { AppBar as MuiAppBar, SxProps, Theme, Toolbar } from '@mui/material';

export const AiAppBar = ({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) => {
  return (
    <MuiAppBar
      elevation={0}
      position="static"
      sx={{ zIndex: 'drawer', bgcolor: 'background.paper', boxShadow: 4, ...sx }}
    >
      <Toolbar sx={{ gap: 2 }}>{children}</Toolbar>
    </MuiAppBar>
  );
};

export default AiAppBar;
